import { render, staticRenderFns } from "./PublicPool.vue?vue&type=template&id=f4524c9c&scoped=true&"
import script from "./PublicPool.vue?vue&type=script&lang=js&"
export * from "./PublicPool.vue?vue&type=script&lang=js&"
import style0 from "./PublicPool.vue?vue&type=style&index=0&id=f4524c9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4524c9c",
  null
  
)

export default component.exports